export const APP_ROUTE_PATHS = Object.freeze([
  '/',
  '/story/:storyId',
  '/weather',
  '/sports',
  '/lottery',
  '/horoscope',
  '/propaganda-machine',
  '/archive/:year/:month',
  '/about',
  '/privacy',
  '/download',
  '/beta',
  '*',
]);

export const APP_ROUTE_MATCHERS = APP_ROUTE_PATHS.map(path => ({ path }));
